import axios from "axios";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const Register = () => {
  const routerPush = useNavigate()

  const [formData, setFormData] = useState({});
  const [namaGweh, setNamaGweh] = useState(null);
  const [ cookies ] = useCookies(["token"]);
  const navigate = useNavigate();

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (
      !cookies.token ||
      cookies.token === null ||
      cookies.token === undefined ||
      cookies.token === "undefined"
    ) {
      navigate("/login");
    } else {
      try {
        // Pastikan cookies.token adalah string dan valid
        const token = cookies.token;
        if (typeof token === "string" && token) {
          const emailGweh = jwtDecode(token).email;
          setNamaGweh(emailGweh);
        } else {
          navigate("/login");
          throw new Error("Invalid token format");
        }
      } catch (error) {
        navigate("/login");
        console.error("Invalid token", error);
      }
    }
  }, [cookies.token, navigate]); // Menambahkan dependencies

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (namaGweh !== null) {
      const response = fetch(`${process.env.REACT_APP_SERVER}/api/user/${namaGweh}`)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
          const thisUser = data.payload.datas;
          if(thisUser.posisi === 'Admin') return routerPush('/admin')
          else if(thisUser.name !== '') return routerPush('/')

          setFormData({
            nama_lengkap: '',
            email: thisUser.email,
            nomor_telepon: '',
            bagian: '',
            posisi: '',
          });
        })
        .catch((error) => setError(`An error occurred: ${error}`))
        .finally(() => setLoading(false));
    }
  }, [namaGweh]);

  if (loading) return <div></div>;
  else if (error) return <div>Error Bos: {error}</div>;

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const responseAttend = await axios.put(
        `${process.env.REACT_APP_SERVER}/api/update-profile`,
        {
          id: data.payload.datas.id,
          name: formData.nama_lengkap,
          no_tel: formData.nomor_telepon,
          bagian: formData.bagian,
          posisi: formData.posisi,
        }
      );
      if(responseAttend.status === 201) {toast.success("Register Request successfully created!")};
      handleClick();
    } catch (error) {
      console.error("Error update data:", error);
      toast.error("Error update data.");
    }
  };



  // Handler untuk menangani perubahan input
  const handleChangeString = (e) => {
    const { name, value } = e.target;

    const thisFormData = formData
    // Perbarui nilai state berdasarkan nama input
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClick = () => {
    routerPush("/")
  }


 

  return (
    <div className="relative min-h-svh bg-slate-100 w-full flex flex-col gap-8  px-4 pt-6 pb-28">
      <p className="text-lg font-bold text-center">Register</p>
      {/* <div className="absolute cursor-pointer text-black " onClick={handlePrev} >
        <CaretLeft size={24} weight="bold" />
      </div> */}
      <div className="flex flex-col gap-4">
        {Object.keys(formData).map((cb, i) => {
          const newWords = cb.split("_").join(" ");
          if (i === 3 || i === 4) {
            return (
              <div className="flex flex-col gap-2" key={i}>
                <p className="text-md font-semibold capitalize">{newWords}</p>
                <select
                  value={formData[cb]}
                  name={cb}
                  onChange={handleChangeString}
                  className="bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400"
                >
                      <option value="" defaultChecked disabled >Select this option</option>
                  {i === 4 ? (
                    <>
                      <option value="Karyawan">Karyawan</option>
                      <option value="Magang">Magang</option>
                    </>
                  ) : (
                    <>
                      <option value="News">News</option>
                      <option value="Produksi">Produksi</option>
                      <option value="Post Produksi">Post Produksi</option>
                      <option value="Lainnya">Lainnya</option>

                    </>
                  )}
                </select>
              </div>
            )
          } else {
            return (
              <div className="flex flex-col gap-2" key={i}>
                <p className="text-md font-semibold capitalize">{newWords}</p>
                <input
                  value={formData[cb]}
                  name={cb}
                  onChange={handleChangeString}
                  disabled={cb === "email"}
                  type={cb === "email" ? "email" : cb === "nomor_telepon" ? "number" : "text"}
                  className={cb === "email" ? "cursor-not-allowed text-gray-600 bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400" : "bg-gray-200 h-10 px-4 border font-normal text-xs rounded-lg border-gray-400"}
                />
              </div>
            );
          }

        })}
      </div>
      <div onClick={handleUpdate} className="flex justify-end absolute bottom-0 right-0 mb-20  me-4">
        <div className="bg-green-700 py-2 text-md rounded-xl px-3 cursor-pointer font-semibold text-white">
          Submit
        </div>
      </div>
    </div>
  );
}

export default Register